<template>
  <div id="contenedor-editar-concepto-catalogo">
    <v-form
      v-model="formularioValido"
      ref="editarConceptoCatalogo">
      <v-card>
        <v-card-title class="secondary--text">
          Editar {{getTipo()}}
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row align="center">
            <!-- <custom-text-field
              cols="12"
              md="6"
              class="py-1"
              v-model="concepto.tipo"
              label="Tipo"
              type="number"
              :rules="[mixReglas.requerido]"
              >
            </custom-text-field> -->
            <!-- <custom-auto-complete
              v-if="catalogoConceptoEditar.tipo === 0 || catalogoConceptoEditar.tipo === 1"
              v-model="concepto.idPadre"
              label="Partida/Padre"
              :items="getPartidasYSubpartidas"
              item-text="conceptoModificado"
              item-value="id">
            </custom-auto-complete> -->
            <custom-auto-complete
              v-model="concepto.idPadre"
              label="Partida/Padre"
              :items="getPartidasYSubpartidas"
              item-text="conceptoModificado"
              item-value="id">
            </custom-auto-complete>
            <custom-text-field
              cols="12"
              md="6"
              class="py-1"
              v-model="concepto.clave"
              label="Clave"
              :rules="[mixReglas.requerido]"
              >
            </custom-text-field>
            <custom-text-area
              cols="12"
              md="12"
              class="py-1"
              v-model="concepto.concepto"
              label="Concepto"
              :rules="[mixReglas.requerido]"
              >
            </custom-text-area>
            <v-row
            v-if="catalogoConceptoEditar.tipo > 1">
              <custom-text-field
              cols="12"
              md="6"
              class="py-1"
              v-model="concepto.unidad"
              label="Unidad"
              >
            </custom-text-field>
            <custom-text-field
              cols="12"
              md="6"
              v-model.number="concepto.cantidad"
              label="Cantidad"
              type="number"
              >
            </custom-text-field>
            <custom-text-field
              cols="12"
              class="pb-1"
              md="6"
              v-model.number="concepto.precioUnitario"
              label="Precio Unitartio"
              type="number"
              prefix="$"
              :rules="[mixReglas.requerido]"
              >
            </custom-text-field>
            </v-row>
            <custom-text-field
              cols="12"
              md="4"
              v-model.number="concepto.orden"
              label="Orden"
              :rules="[mixReglas.requerido]"
              >
            </custom-text-field>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarCatalogoConcepto"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixCatalogo from './mixCatalogo';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomButton from '@/components/buttons/Button.vue';
import CustomAutoComplete from '@/components/inputs/Autocomplete.vue';

export default {
  name: 'EditarConceptoCatalogoContrato',
  mixins: [mixCatalogo],
  props: {
    catalogoConceptoEditar: {
      type: Object,
      required: true,
    },
    partidas: {
      type: Array,
    },
  },
  components: {
    CustomTextField,
    CustomButton,
    CustomTextArea,
    CustomAutoComplete,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      concepto: {
        idPadre: this.catalogoConceptoEditar.idPadre,
        tipo: this.catalogoConceptoEditar.tipo,
        clave: this.catalogoConceptoEditar.clave,
        concepto: this.catalogoConceptoEditar.concepto,
        unidad: this.catalogoConceptoEditar.unidad,
        cantidad: this.catalogoConceptoEditar.cantidad,
        precioUnitario: this.catalogoConceptoEditar.precioUnitario,
        importe: this.catalogoConceptoEditar.importe,
        orden: this.catalogoConceptoEditar.orden,
      },
    };
  },
  methods: {
    getTipo() {
      switch (this.catalogoConceptoEditar.tipo) {
        case 0:
          return 'Partida';
        case 1:
          return 'Subpartida';
        case 2:
          return 'Concepto';
        default:
          return 'Partida';
      }
    },
    setImporte() {
      const { cantidad, precioUnitario } = this.concepto;
      this.concepto.importe = cantidad * precioUnitario;
    },
    cerrar() {
      this.$emit('cerrar');
    },
  },
  computed: {
    getPartidasYSubpartidas() {
      if (!this.partidas) return [];
      const partidasYSubpartidas = this.partidas.map((partida) => ({
        ...partida,
      }));
      const index = partidasYSubpartidas
        .findIndex((partida) => partida.id === this.catalogoConceptoEditar.id);
      if (index !== -1) {
        partidasYSubpartidas.splice(index, 1);
      }
      return partidasYSubpartidas;
    },
    cantidad() {
      return this.concepto.cantidad;
    },
    precioUnitario() {
      return this.concepto.precioUnitario;
    },
  },
  watch: {
    'concepto.idPadre': {
      handler(idPadre) {
        if ((this.concepto.tipo === 0 || this.concepto.tipo === 1) && idPadre) {
          this.concepto.tipo = 1;
        }

        if (!idPadre) {
          this.concepto.tipo = 0;
        }
      },
    },
    cantidad() {
      this.setImporte();
    },
    precioUnitario() {
      this.setImporte();
    },
  },

};
</script>

<style>

</style>
